import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import i18n from '../../utils/i18n';
import { withTranslation } from 'react-i18next';
import axios from '../../shared/axios/axiosProxy';
import { withRouter } from '../../withRouter';
import { useNavigate } from 'react-router';
import auth from '../auth/auth';
import { Snackbar, Alert } from '@mui/material';
import LoginInputs from './loginInputs/loginInputs';
// import telekom from '../images/telekom.svg';
// import mbh from '../images/mbh.svg';
// import perfekt from '../images/perfekt.svg';
import logo from '../images/bookkeepie-logo.svg';
import headset from '../images/icon-headset.svg';

import classes from './providerEntry.module.scss';

const Confirmation = () => {
	const [openSnack, setOpenSnack] = useState(false);
	const { JWT } = useParams();
	const navigate = useNavigate();

	useEffect(() => {
		axios
			.get(`/api/auth/register/${JWT}`, {})
			.then((response) => {
				setOpenSnack(true);
				//console.log('Response data: ', response.data);
			})
			.catch((error) => {
				console.log('AXIOS ERROR: ', error.response.data);
			});
	}, []);

	useEffect(() => {
		/*     console.log(auth.isAuthenticated()); */
		if (auth.isAuthenticated()) {
			navigate('/provider/dashboard');
		}
	}, [navigate]);

	const handleClose = (event, reason) => {
		if (reason === 'clickaway') {
			return;
		}
		setOpenSnack(false);
	};

	return (
		<div className={classes.EntryContainer}>
			<Snackbar
				open={openSnack}
				autoHideDuration={3000}
				onClose={(e) => handleClose(e)}>
				<Alert
					onClose={handleClose}
					severity="success"
					variant="filled"
					sx={{ width: '100%' }}>
					{i18n.t('general.successfulreg')}
				</Alert>
			</Snackbar>
			<div className={classes.EntryHeader}>
				<img src={logo} alt="bookkeepie" className={classes.EntryLogo} />
				<div>
					<span className={classes.MediumText}>
						{i18n.t('general.doyouhavenotyetanaccount')}
					</span>
					{/* <span className={classes.Blue14}> */}
					<a
						className={classes.noDecoration && classes.Blue14}
						href="/provider/register">
						{i18n.t('general.iamregistering')}
					</a>
					{/* </span> */}
				</div>
			</div>
			<div className={classes.EntryFields}>
				<div className={classes.EntryFieldsBox}>
					<p className={classes.Blue10}>{i18n.t('general.forproviders')}</p>
					<p className={classes.EntryTitle}>{i18n.t('general.iamloggingin')}</p>
					<p className={classes.MediumText}>
						{i18n.t('general.providedetailsandlogin')}
					</p>
					<div className={classes.providerLoginPaper}>
						<LoginInputs />
						<div className={classes.flexCenter}>
							<span className={classes.MediumText}>
								{i18n.t('general.doyouhavenotyetanaccount')}
							</span>
							<a
								className={classes.noDecoration && classes.Blue14}
								href="/provider/register">
								{i18n.t('general.iamregistering')}
							</a>
						</div>
					</div>
				</div>
				<div className={classes.EntryIssueContact}>
					<img src={headset} alt="headset" />
					<span
						className={classes.SmallText}
						style={{ textDecorationLine: 'none' }}>
						{i18n.t('general.isthereaproblem')}
					</span>
					<span
						className={classes.Blue12}
						style={{ textDecorationLine: 'none' }}>
						<a
							className={classes.noDecoration}
							href="https://ie.bookkeepie.com/contact-us"
							target="_blank"
							rel="noreferrer">
							{i18n.t('general.contactus')}
						</a>
					</span>
				</div>
				{/* <div className={classes.EntryPartners}>
					<img src={telekom} alt="telekom partner" />
					<img src={mbh} alt="mbh partner" />
					<img src={perfekt} alt="perfekt partner" />
				</div> */}
			</div>
			<div className={classes.LoginBlueBox}></div>
		</div>
	);
};

export default withTranslation()(withRouter(Confirmation));
